import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const ArrowRightIcon = observer('ArrowRightIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.0001 2L22.0001 12L12.0001 22L10.2457 20.2456L17.2048 13.228H2V10.7719H17.2048L10.2457 3.75433L12.0001 2Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
